import cn from 'classnames';
import styles from './ProgressBar.module.scss';

export type ProgressBarProps = Partial<{
  className: string;
  title: string;
  steps: number;
  activeStep: number;
}>;

export const ProgressBar = ({ className = '', title, steps, activeStep = 1 }: ProgressBarProps) => {
  const getClassNames = (index: number) => {
    return cn({
      [styles.step]: true,
      [styles.activeStep]: activeStep >= index,
    });
  };

  const stepsAmount = new Array(steps).fill(null);

  return (
    <div className={className}>
      {title && <p className={styles.title}>{title}</p>}

      <ul className={styles.stepList}>
        {stepsAmount.map((_, index) => (
          <li key={index} className={getClassNames(index + 1)}></li>
        ))}
      </ul>
    </div>
  );
};

export default ProgressBar;
